<template>
  <v-toolbar dark color="primary">
    <v-btn icon dark @click="$emit('close')">
      <v-icon>close</v-icon>
    </v-btn>
    <v-toolbar-title>{{ title }}</v-toolbar-title>
    <v-spacer />
    <v-toolbar-items>
      <v-btn
        v-if="!hideSave"
        :disabled="disableSave"
        dark
        flat
        @click="$emit('save')"
      > <span v-t="'common.save'" /> </v-btn>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
export default {
  name: 'ModalToolbar',
  props: {
    title: {
      type: String,
      default: '',
    },
    disableSave: Boolean,
    hideSave: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="css">
</style>
